// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import { imagePath } from 'frontend_core/dist/helpers/image'
import UserIcon from 'components/atoms/UserIcon'
import Icon from 'components/atoms/Icon'

const Wrapper = styled.div`
  margin-right: 50px;
  &::after {
    display: block;
    clear: both;
    content: '';
  }
  ${mediaMax.phone`
    margin-right: 0;
  `};
`

const Container = styled.div`
  display: table;
  table-layout: fixed;
`

const StatusWrapper = styled.div`
  display: inline-block;
  padding-left: ${spacing.small_2}px;
  vertical-align: bottom;
`

const Status = styled.span`
  display: inline-block;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: right;
  line-height: 1.5;
`

const MessageWrapper = styled.div`
  display: table-cell;
  width: 290px;
  padding: ${spacing.small_2}px 0 ${spacing.small_2}px ${spacing.small_2}px;
  ${mediaMax.phone`
    width: 264px;
  `};
`

const UserIconContainer = styled.div`
  display: table-cell;
  width: 40px;
`
const FileTitle = styled.div`
  padding: ${spacing.small_2}px ${spacing.small_3}px;
  color: ${Colors.blue};
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  vertical-align: bottom;
  ${mediaMin.phone`
    padding: ${spacing.medium}px;
  `};
`

const UserIconWrapper = styled.div`
  margin-bottom: -${spacing.small_3}px;
`

const MessageContent = styled.div`
  display: inline-block;
  width: 100%;
  max-width: calc(100% - 40px);
  background-color: ${Colors.grayF};
  border: 2px solid ${Colors.grayF};
  border-radius: 16px;
  border-bottom-left-radius: ${borderRadius}px;
  overflow: hidden;
  font-size: ${fontSize.small_3}px;
`

const PdfThumbnailContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 55.67%;
`

const PdfThumbnail = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: ${Colors.white};
  ${({ imageUrl }) => `
    background-image: url('${imageUrl}');
  `} background-size: 45px;
  background-repeat: no-repeat;
  background-position: center;
`

type PropTypes = {
  time?: string,
  opponentImage: string,
  filename: string,
  fileUrl: string,
}

export default (props: PropTypes) => (
  <Wrapper>
    <Container>
      <UserIconContainer>
        <UserIconWrapper>
          <UserIcon src={props.opponentImage} medium />
        </UserIconWrapper>
      </UserIconContainer>
      <MessageWrapper>
        <MessageContent>
          <a href={props.fileUrl} target="_blank">
            <PdfThumbnailContainer>
              <PdfThumbnail imageUrl={imagePath('common/file.svg')} />
            </PdfThumbnailContainer>
            <FileTitle>
              <Icon type="paperclip" positionType="left" />
              {props.filename}
            </FileTitle>
          </a>
        </MessageContent>
        <StatusWrapper>
          <Status>{props.time}</Status>
        </StatusWrapper>
      </MessageWrapper>
    </Container>
  </Wrapper>
)



// WEBPACK FOOTER //
// ./src/components/molecules/message/SendFileOpponent/index.jsx